import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'
import {
  getSupplierComplianceKpiCardData,
  getSupplierComplianceNetwork,
  getSupplierComplianceRiskSummary,
} from './compliance.async'

const initialState = {
  supplierComplianceKpiCardLoader: false,
  supplierComplianceKpiCardData: {},
  supplierComplianceRIskSummaryLoader: false,
  supplierComplianceRIskSummaryData: {},
  supplierComplianceNetworkLoader: false,
  supplierComplianceNetworkData: {},
}

const ComplianceReducer = createSlice({
  name: 'ComplianceReducer',
  initialState,
  reducers: {
    emptyComplianceReducer: (state) => {},
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getSupplierComplianceKpiCardData.pending), (state) => {
      state.supplierComplianceKpiCardLoader = true
    })
    builder.addMatcher(isAnyOf(getSupplierComplianceKpiCardData.fulfilled), (state, action) => {
      state.supplierComplianceKpiCardLoader = false
      state.supplierComplianceKpiCardData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getSupplierComplianceKpiCardData.rejected), (state) => {
      state.supplierComplianceKpiCardLoader = false
    })
    builder.addMatcher(isAnyOf(getSupplierComplianceRiskSummary.pending), (state) => {
      state.supplierComplianceRIskSummaryLoader = true
    })
    builder.addMatcher(isAnyOf(getSupplierComplianceRiskSummary.fulfilled), (state, action) => {
      state.supplierComplianceRIskSummaryLoader = false
      state.supplierComplianceRIskSummaryData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getSupplierComplianceRiskSummary.rejected), (state) => {
      state.supplierComplianceRIskSummaryLoader = false
    })
    builder.addMatcher(isAnyOf(getSupplierComplianceNetwork.pending), (state) => {
      state.supplierComplianceNetworkLoader = true
    })
    builder.addMatcher(isAnyOf(getSupplierComplianceNetwork.fulfilled), (state, action) => {
      state.supplierComplianceNetworkLoader = false
      state.supplierComplianceNetworkData = action.payload.data
    })
    builder.addMatcher(isAnyOf(getSupplierComplianceNetwork.rejected), (state) => {
      state.supplierComplianceNetworkLoader = false
    })
  },
})

export const { emptyComplianceReducer } = ComplianceReducer.actions
export default ComplianceReducer.reducer
